<script>
import Swal from "sweetalert2";
import { cloneDeep } from "lodash";
import { required } from "vuelidate/lib/validators";
import EmployeeModal from "@/components/modals/employee.vue";
import RawData from "@/components/widgets/raw-data.vue";
import ClusterSignatoryModal from "@/components/modals/cluster-signatory-modal.vue";

export default {
    components: {
        EmployeeModal,
        RawData,
        ClusterSignatoryModal
    },
    data() {
        return {
            submitted: false,
            tableData: [],
            modalTitle: "",
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: [],
            sortBy: "clusterName",
            sortDesc: false,
            fields: [
                {
                    key: "clusterName",
                    sortable: true,
                },
                {
                    key: "clusterHead",
                    sortable: true,
                },
                {
                    label: "PMT Members",
                    key: "pmtMembers",
                    sortable: true,
                },
                {
                    key: "actions",
                    thStyle: { width: "90px" },
                },
            ],
            form: {
                id: 0,
                clusterName: "",
                clusterHeadId: "",
                clusterHead: "",
                clusterHeadPosition: "",
                pmtMember1Id: "",
                pmtMember1: "",
                pmtMember1Position: "",
                pmtMember2Id: "",
                pmtMember2: "",
                pmtMember2Position: "",
                pmtMember3Id: "",
                pmtMember3: "",
                pmtMember3Position: "",
                pmtMember4Id: "",
                pmtMember4: "",
                pmtMember4Position: "",
                pmtMember5Id: "",
                pmtMember5: "",
                pmtMember5Position: "",
            },
            indexSelected: -1,
            tableBusy: false,
            headType: "",
        };
    },
    computed: {
        rows() {
            if(this.filter){
                return this.totalRows;
            }
            return this.tableData.length;
        },
    },
    validations: {
        form: {
            clusterName: { required },
            clusterHead: { required },
        },
    },
    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        addCluster() {
            this.onReset();
            this.modalTitle = "Create New Cluster";
            this.$bvModal.show("cl-modal");
        },
        onReset() {
            this.form = {
                id: 0,
                clusterName: "",
                clusterHeadId: "",
                clusterHead: "",
                clusterHeadPosition: "",
                pmtMember1Id: "",
                pmtMember1: "",
                pmtMember1Position: "",
                pmtMember2Id: "",
                pmtMember2: "",
                pmtMember2Position: "",
                pmtMember3Id: "",
                pmtMember3: "",
                pmtMember3Position: "",
                pmtMember4Id: "",
                pmtMember4: "",
                pmtMember4Position: "",
                pmtMember5Id: "",
                pmtMember5: "",
                pmtMember5Position: "",
            };
        },
        selectHead(type){
            this.headType = type;
            this.$refs.empModal.getSingleSelection();
            this.$bvModal.show("employee-modal");
        },
        dropSingleEmployee(employee) {
            if(this.headType === "pmt1"){
                this.form.pmtMember1Id = employee.applicationUser.id;
                this.form.pmtMember1 = employee.applicationUser.completeName;
                this.form.pmtMember1Position = employee.position;
            }else if(this.headType === "pmt2"){
                this.form.pmtMember2Id = employee.applicationUser.id;
                this.form.pmtMember2 = employee.applicationUser.completeName;
                this.form.pmtMember2Position = employee.position;
            }else if(this.headType === "pmt3"){
                this.form.pmtMember3Id = employee.applicationUser.id;
                this.form.pmtMember3 = employee.applicationUser.completeName;
                this.form.pmtMember3Position = employee.position;
            }else if(this.headType === "pmt4"){
                this.form.pmtMember4Id = employee.applicationUser.id;
                this.form.pmtMember4 = employee.applicationUser.completeName;
                this.form.pmtMember4Position = employee.position;
            }else if(this.headType === "pmt5"){
                this.form.pmtMember5Id = employee.applicationUser.id;
                this.form.pmtMember5 = employee.applicationUser.completeName;
                this.form.pmtMember5Position = employee.position;
            }else{
                this.form.clusterHeadId = employee.applicationUser.id;
                this.form.clusterHead = employee.applicationUser.completeName;
                this.form.clusterHeadPosition = employee.position;
            }
        },
        hideModal() {
            this.$bvModal.hide("cl-modal");
        },
        onCreate() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                if (this.form.id > 0) {
                    this.$store
                        .dispatch("cluster/UpdateCluster", this.form)
                        .then((res) => {
                            if(res.data.error){
                                return this.showToast(res.data.errorMessage,"error");
                            }
                            this.tableData.splice(
                                this.indexSelected,
                                1,
                                this.form
                            );
                            this.$bvModal.hide("cl-modal");
                            this.showToast("Successfully updated!","success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!","error");
                        });
                } else {
                    this.$store
                        .dispatch("cluster/CreateCluster", this.form)
                        .then((res) => {
                            if(res.data.error){
                                return this.showToast(res.data.errorMessage,"error");
                            }
                            res.data.clusterHead = this.form.clusterHead;
                            this.tableData.push(res.data);
                            this.$bvModal.hide("cl-modal");
                            this.showToast("Successfully created!","success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!","error");
                        });
                }
                this.submitted = false;
            }
        },
        updateItem(props) {
            this.form = cloneDeep(props.item);
            this.form.pmtMember1 = props.item.pmtMember1 || '';
            this.form.pmtMember2 = props.item.pmtMember2 || '';
            this.form.pmtMember3 = props.item.pmtMember3 || '';
            this.form.pmtMember4 = props.item.pmtMember4 || '';
            this.form.pmtMember5 = props.item.pmtMember5 || '';
            this.indexSelected = this.tableData.indexOf(props.item);
            this.modalTitle = "Update Cluster";
            this.$bvModal.show("cl-modal");
        },
        deleteItem(props) {
            var index = this.tableData.indexOf(props.item);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("cluster/DeleteCluster", props.item.id)
                        .then((res) => {
                            if(res.data.error){
                                return this.showToast(res.data.errorMessage,"error");
                            }
                            this.tableData.splice(index, 1);
                            this.showToast("Successfully deleted!","success");
                        })
                        .catch((err) => {
                            this.showToast("Cannot be deleted!","error");
                        });
                }
            });
        },
        getClusters() {
            this.tableBusy = true;
            this.$store
                .dispatch("cluster/GetCluster")
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage,"error");
                    }
                    this.tableBusy = false;
                    this.tableData = res.data;
                })
                .catch(() => {
                    this.tableBusy = false;
                    this.showToast("Something went wrong!","error");
                });
        },
        removeHead(type){
            if(type === "pmt1"){
                this.form.pmtMember1Id = "";
                this.form.pmtMember1 = "";
                this.form.pmtMember1Position = "";
            }else if(type === "pmt2"){
                this.form.pmtMember2Id = "";
                this.form.pmtMember2 = "";
                this.form.pmtMember2Position = "";
            }else if(type === "pmt3"){
                this.form.pmtMember3Id = "";
                this.form.pmtMember3 = "";
                this.form.pmtMember3Position = "";
            }else if(type === "pmt4"){
                this.form.pmtMember4Id = "";
                this.form.pmtMember4 = "";
                this.form.pmtMember4Position = "";
            }else if(type === "pmt5"){
                this.form.pmtMember5Id = "";
                this.form.pmtMember5 = "";
                this.form.pmtMember5Position = "";
            }else{
                this.form.clusterHeadId = "";
                this.form.clusterHead = "";
                this.form.clusterHeadPosition = "";
            }
        },
        viewSignatory(item){
            this.$bvModal.show("cluster-signatory-modal");
            this.$refs.clusterSignatory.getData(item);
        }
    }
};
</script>

<template>
    <div>
        <b-modal
            id="cl-modal"
            :title="modalTitle"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
        >
            <form
                @submit.prevent="onCreate"
                class="needs-validation"
                ref="slForm"
            >
                <div class="mb-3">
                    <label for="clusterName">Cluster Name </label>
                    <input
                        autocomplete="off"
                        id="clusterName"
                        type="text"
                        v-model="form.clusterName"
                        placeholder="Enter Cluster Name..."
                        class="form-control"
                        :class="{
                            'is-invalid':
                                submitted &&
                                $v.form.clusterName.$error,
                        }"
                    />
                    <div
                        v-if="submitted && $v.form.clusterName.$error"
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.form.clusterName.required"
                            >This value is required.</span
                        >
                    </div>
                </div>
                <label for="clusterHead">Cluster Head</label>
                <b-input-group class="mb-3">
                  <template #append>
                        <b-button
                            @click="selectHead('cluster-head')"
                            variant="outline-info"
                            ><i class="mdi mdi-clipboard-text-search-outline"></i
                        ></b-button>
                        <b-button
                            @click="removeHead('cluster-head')"
                            variant="outline-danger"
                            ><i class="bx bx-x"></i
                        ></b-button>
                    </template>
                    <input
                        autocomplete="off"
                        id="signatory"
                        type="text"
                        v-model="form.clusterHead"
                        placeholder="Select Cluster Head..."
                        class="form-control"
                        disabled
                        :class="{
                            'is-invalid':
                                submitted &&
                                $v.form.clusterHead.$error,
                        }"
                    />
                    <div
                        v-if="submitted && $v.form.clusterHead.$error"
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.form.clusterHead.required"
                            >This value is required.</span
                        >
                    </div>
                </b-input-group>
                <div class="mb-3">
                    <input
                        autocomplete="off"
                        id="clusterHeadPosition"
                        type="text"
                        v-model="form.clusterHeadPosition"
                        placeholder="Enter Cluster Head Position..."
                        class="form-control"
                    />
                </div>
                <label for="pmtMember1Position">PMT 1</label>
                <b-input-group class="mb-3">
                  <template #append>
                        <b-button
                            @click="selectHead('pmt1')"
                            variant="outline-info"
                            ><i class="mdi mdi-clipboard-text-search-outline"></i
                        ></b-button>
                        <b-button
                            @click="removeHead('pmt1')"
                            variant="outline-danger"
                            ><i class="bx bx-x"></i
                        ></b-button>
                    </template>
                    <input
                        autocomplete="off"
                        id="signatory"
                        type="text"
                        v-model="form.pmtMember1"
                        placeholder="Select PMT 1..."
                        class="form-control"
                        disabled
                    />
                </b-input-group>
                <div class="mb-3">
                    <input
                        autocomplete="off"
                        id="pmtMember1Position"
                        type="text"
                        v-model="form.pmtMember1Position"
                        placeholder="Enter PMT 1 Position..."
                        class="form-control"
                    />
                </div>
                <label for="pmtMember1Position">PMT 2</label>
                <b-input-group class="mb-3">
                  <template #append>
                        <b-button
                            @click="selectHead('pmt2')"
                            variant="outline-info"
                            ><i class="mdi mdi-clipboard-text-search-outline"></i
                        ></b-button>
                        <b-button
                            @click="removeHead('pmt2')"
                            variant="outline-danger"
                            ><i class="bx bx-x"></i
                        ></b-button>
                    </template>
                    <input
                        autocomplete="off"
                        id="signatory"
                        type="text"
                        v-model="form.pmtMember2"
                        placeholder="Select PMT 2..."
                        class="form-control"
                        disabled
                    />
                </b-input-group>
                <div class="mb-3">
                    <input
                        autocomplete="off"
                        id="pmtMember2Position"
                        type="text"
                        v-model="form.pmtMember2Position"
                        placeholder="Enter PMT 2 Position..."
                        class="form-control"
                    />
                </div>
                <label for="pmtMember1Position">PMT 3</label>
                <b-input-group class="mb-3">
                  <template #append>
                        <b-button
                            @click="selectHead('pmt3')"
                            variant="outline-info"
                            ><i class="mdi mdi-clipboard-text-search-outline"></i
                        ></b-button>
                        <b-button
                            @click="removeHead('pmt3')"
                            variant="outline-danger"
                            ><i class="bx bx-x"></i
                        ></b-button>
                    </template>
                    <input
                        autocomplete="off"
                        id="signatory"
                        type="text"
                        v-model="form.pmtMember3"
                        placeholder="Select PMT 3..."
                        class="form-control"
                        disabled
                    />
                </b-input-group>
                <div class="mb-3">
                    <input
                        autocomplete="off"
                        id="pmtMember3Position"
                        type="text"
                        v-model="form.pmtMember3Position"
                        placeholder="Enter PMT 3 Position..."
                        class="form-control"
                    />
                </div>
                <label for="pmtMember1Position">PMT 4</label>
                <b-input-group class="mb-3">
                  <template #append>
                        <b-button
                            @click="selectHead('pmt4')"
                            variant="outline-info"
                            ><i class="mdi mdi-clipboard-text-search-outline"></i
                        ></b-button>
                        <b-button
                            @click="removeHead('pmt4')"
                            variant="outline-danger"
                            ><i class="bx bx-x"></i
                        ></b-button>
                    </template>
                    <input
                        autocomplete="off"
                        id="signatory"
                        type="text"
                        v-model="form.pmtMember4"
                        placeholder="Select PMT 4..."
                        class="form-control"
                        disabled
                    />
                </b-input-group>
                <div class="mb-3">
                    <input
                        autocomplete="off"
                        id="pmtMember4Position"
                        type="text"
                        v-model="form.pmtMember4Position"
                        placeholder="Enter PMT 4 Position..."
                        class="form-control"
                    />
                </div>
                <label for="pmtMember1Position">PMT 5</label>
                <b-input-group class="mb-3">
                  <template #append>
                        <b-button
                            @click="selectHead('pmt5')"
                            variant="outline-info"
                            ><i class="mdi mdi-clipboard-text-search-outline"></i
                        ></b-button>
                        <b-button
                            @click="removeHead('pmt5')"
                            variant="outline-danger"
                            ><i class="bx bx-x"></i
                        ></b-button>
                    </template>
                    <input
                        autocomplete="off"
                        id="signatory"
                        type="text"
                        v-model="form.pmtMember5"
                        placeholder="Select PMT 5..."
                        class="form-control"
                        disabled
                    />
                </b-input-group>
                <div class="mb-3">
                    <input
                        autocomplete="off"
                        id="pmtMember5Position"
                        type="text"
                        v-model="form.pmtMember5Position"
                        placeholder="Enter PMT 5 Position..."
                        class="form-control"
                    />
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary">
                        Save changes
                    </button>
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="hideModal"
                    >
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <div class="row">
            <div class="col-12">
                <div
                    class="
                        card
                        border
                    "
                >
                    <div class="card-body">
                        <div
                            class="
                                d-flex
                                justify-content-between
                                align-items-center
                            "
                        >
                            <h4 class="card-title m-0">Cluster List</h4>
                            <button
                                type="button"
                                @click="addCluster()"
                                class="
                                    btn btn-md btn-info
                                    d-flex
                                    align-items-center
                                "
                            >
                                <i class="bx bx-plus fs-6"></i>Create New
                            </button>
                        </div>
                        <div class="row mt-4">
                            <div class="col-sm-12 col-md-6">
                                <div
                                    id="tickets-table_length"
                                    class="dataTables_length"
                                >
                                    <label
                                        class="d-inline-flex align-items-center"
                                    >
                                        Show&nbsp;
                                        <b-form-select
                                            class="form-select form-select-sm"
                                            v-model="perPage"
                                            size="sm"
                                            :options="pageOptions"
                                        ></b-form-select
                                        >&nbsp;entries
                                    </label>
                                </div>
                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div
                                    id="tickets-table_filter"
                                    class="dataTables_filter text-md-end"
                                >
                                    <label
                                        class="d-inline-flex align-items-center"
                                    >
                                        Search:
                                        <b-form-input
                                            autocomplete="off"
                                            v-model="filter"
                                            type="search"
                                            placeholder="Search..."
                                            class="
                                                form-control form-control-sm
                                                ms-2
                                            "
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <div class="table-responsive mb-0">
                            <b-table
                                class="datatables"
                                :items="tableData"
                                :fields="fields"
                                responsive="sm"
                                :per-page="perPage"
                                :current-page="currentPage"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                :filter="filter"
                                :filter-included-fields="filterOn"
                                :busy="tableBusy"
                                @filtered="onFiltered"
                                bordered
                                outlined
                                hover
                                striped
                                show-empty
                            >
                                <template #empty="scope">
                                    <div class="text-center">{{ scope.emptyText }}</div>
                                </template>
                                <template #table-busy>
                                    <div
                                        class="
                                            d-flex
                                            justify-content-center
                                            align-items-center
                                        "
                                    >
                                        <div class="preloader-component me-2">
                                            <div class="status">
                                                <div
                                                    class="
                                                        spinner-chase
                                                        w-20px
                                                        h-20px
                                                    "
                                                >
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                </div>
                                            </div>
                                        </div>
                                        <strong>Loading...</strong>
                                    </div>
                                </template>
                                <template #cell(clusterName)="row">
                                    <div class="position-relative">
                                        <RawData :data="row.item" v-if="$store.state.decrypt.isAdmin()" />
                                        {{row.item.clusterName}}
                                        <div>
                                            <button class="btn btn-outline-info btn-sm mt-1" @click="viewSignatory(row.item)">View Signatory</button>
                                        </div>
                                    </div>
                                </template>
                                <template #cell(clusterHead)="row">
                                    <div>
                                        {{row.item.clusterHead}}
                                    </div>
                                    <small>{{row.item.clusterHeadPosition}}</small>
                                </template>
                                <template #cell(pmtMembers)="row">
                                    <template v-for="x in 5">
                                    <div :key="x" class="border border-secondary mb-1 px-2 py-2" v-if="row.item[`pmtMember${x}`]">
                                        <div class="line-height-1">
                                            PMT {{x}}: <span class="text-info">{{row.item[`pmtMember${x}`]}}</span>
                                        </div>
                                        <small>PMT {{x}} Position: <span class="text-info">{{row.item[`pmtMember${x}Position`]}}</span></small>
                                    </div>
                                    </template>
                                </template>
                                <template #cell(actions)="row">
                                    <div class="float-end">
                                        <b-dropdown
                                            id="dropdown-dropleft"
                                            right
                                            variant="link"
                                            toggle-class="text-decoration-none"
                                            menu-class="dropdown-menu-end"
                                            no-caret
                                        >
                                            <template #button-content>
                                                <i
                                                    class="fas fa-ellipsis-v"
                                                ></i>
                                            </template>
                                            <b-dropdown-item
                                                @click="updateItem(row)"
                                                variant="secondary"
                                                ><i
                                                    class="
                                                        mdi mdi-update
                                                        font-size-18
                                                        me-1
                                                    "
                                                ></i
                                                >Edit</b-dropdown-item
                                            >
                                            <b-dropdown-item
                                                @click="deleteItem(row)"
                                                variant="danger"
                                                ><i
                                                    class="
                                                        mdi mdi-trash-can
                                                        font-size-18
                                                        me-1
                                                    "
                                                ></i
                                                >Delete</b-dropdown-item
                                            >
                                        </b-dropdown>
                                    </div>
                                </template>
                            </b-table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div
                                    class="
                                        dataTables_paginate
                                        paging_simple_numbers
                                        float-end
                                    "
                                >
                                    <ul
                                        class="
                                            pagination pagination-rounded
                                            mb-0
                                        "
                                    >
                                        <!-- pagination -->
                                        <b-pagination
                                            v-model="currentPage"
                                            :total-rows="rows"
                                            :per-page="perPage"
                                        ></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <employee-modal
            ref="empModal"
            @dropData="dropSingleEmployee"
        ></employee-modal>
        <ClusterSignatoryModal ref="clusterSignatory" />
    </div>
</template>